import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@mui/material';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const BASE_RANDOMNESS_TEMPLATE = [
  { name: '0 (Deterministic)', value: 0, color: '#90caf9' },
  { name: '0.3 (Focused)', value: 0, color: '#42a5f5' },
  { name: '0.5 (Balanced)', value: 0, color: '#1e88e5' },
  { name: '0.7 (Creative)', value: 0, color: '#1565c0' },
  { name: '1.0 (Random)', value: 0, color: '#0d47a1' },
];

const RandomnessDonutChart = ({ data = [] }) => {
  const chartData = useMemo(() => {
    return BASE_RANDOMNESS_TEMPLATE.map((item) => {
      const labelValue = parseFloat(item.name.split(" ")[0]);

      const match = data.find(
        (d) => Number(d.randomness) === labelValue
      );

      return {
        ...item,
        value: match?.count ?? 0,
      };
    });
  }, [data]);

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        borderRadius: 2,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          Randomness Selection Breakdown
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Distribution of selected temperature settings across proposals
        </Typography>
      </Box>

      <Box sx={{ width: '100%', height: 320 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={100}
              paddingAngle={4}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={index} fill={entry.color} />
              ))}
            </Pie>

            <Tooltip
              formatter={(value) => [`${value} proposals`, 'Count']}
              contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
            />

            <Legend
              layout="vertical"
              verticalAlign="middle"
              align="right"
              wrapperStyle={{ fontSize: 13 }}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

RandomnessDonutChart.propTypes = {
  data: PropTypes.array,
};

export default RandomnessDonutChart;